import { createFileRoute } from '@tanstack/react-router'
import Dashboard from '@/features/dashboard'
import { RouteGuard } from '@/components/RouteGuard'

type DashboardSearch = {
  newShop?: string
}

export const Route = createFileRoute('/_authenticated/')({
  validateSearch: (search: Record<string, unknown>): DashboardSearch => ({
    newShop: typeof search.newShop === 'string' ? search.newShop : undefined,
  }),
  component: () => (
    <RouteGuard>
      <Dashboard />
    </RouteGuard>
  ),
})
